<!------------------------------------------------------------------------------
 File: addToBookmark 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 12/10/2018
 Time: 14:51
------------------------------------------------------------------------------->
<template>
    <div class=""
         :class="btn_class"

         v-on:click="add">
        <i class="material-icons fs-3">favorite</i>
    </div>
</template>

<script>
    import { BOOKMARKS_COMMUNICATIONS } from '../../config';

    export default {
        name: 'add_to_bookmark',
        components: {},
        props: {
            store: {
                type: String
            },
            route: {
                type: Object|String
            },
            btn_class:{
                type:String,
                default:()=>{
                    return 'btn btn-floating btn-info';
                }
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            //            console.log('mounted');
            if (typeof this.route === 'string' || this.route instanceof String)
                this.set_route = JSON.parse(this.route);
            else
                this.set_route = this.route;
        },
        data() {
            return {
                default_classes:[
                    'btn' ,'btn-floating','btn-info'
                ],
                set_route: {}
            };
        },
        methods: {
            add() {
                let _this = this,
                    data = {
                        route_data: _this.set_route
                    };
                //                console.log('add', 'data',data);
                // console.log('add', 'this.set_route',this.set_route);
                axios.post(_this.store, data)
                    .then(function(response) {
                        if (response.data.success) {
                            // console.log('HUB', 'BOOKMARKS_COMMUNICATIONS',BOOKMARKS_COMMUNICATIONS);
                            //console.log('bookmarks_navigation--wrapper', 'GLOBAL_VUEJS',GLOBAL_VUEJS['bookmarks_navigation--wrapper']);
                            //  GLOBAL_VUEJS['bookmarks_navigation--wrapper'].update();
                            BOOKMARKS_COMMUNICATIONS.$emit('reload', true);
                        }
                    })
                    .catch(function() {

                    });
            }
        },
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navigation/addToBookmark.vue?99c710d2